<template>
  <div data-v-249f9abc="" class="wrapper clearfix">
    <div data-v-1dc60391="" data-v-249f9abc="" class="content clearfix">
      <div data-v-1dc60391="" class="main">
        <div data-v-3ff3db88="" data-v-1dc60391="" class="main">
          <div data-v-3ff3db88="" class="success_content">
            <p data-v-3ff3db88="" class="suc_title">个人客户用水报装</p>
          </div>
          <form data-v-3ff3db88="" class="el-form demo-ruleForm">
            <h4 data-v-3ff3db88="" style="margin-top: 15px; margin-bottom: 15px;">认证方式</h4>
            <div data-v-3ff3db88="" class="el-form-item">
              <!---->
              <div class="el-form-item__content">
                <div data-v-3ff3db88="" class="certificate_type">
                  <div data-v-3ff3db88="" class="el-row">
                    <div data-v-3ff3db88="" class="el-col el-col-5">认证方式</div>
                    <div data-v-3ff3db88="" class="el-col el-col-19">
                      <div data-v-3ff3db88="" role="radiogroup" class="el-radio-group"><label data-v-3ff3db88="" role="radio" tabindex="0" class="el-radio radio_text"
                               style="font-size: 16px !important;"><span class="el-radio__input"><span class="el-radio__inner"></span><input type="radio" aria-hidden="true" tabindex="-1"
                                   class="el-radio__original" value="1"></span><span class="el-radio__label">办理人刷脸验证
                            <!---->
                          </span></label> <label data-v-3ff3db88="" role="radio" tabindex="-1" class="el-radio radio_text" style="font-size: 16px !important;"><span class="el-radio__input"><span
                                  class="el-radio__inner"></span><input type="radio" aria-hidden="true" tabindex="-1" class="el-radio__original" value="2"></span><span
                                class="el-radio__label">办理人填写上传身份信息
                            <!---->
                          </span></label></div>
                    </div>
                  </div>
                </div>
                <!---->
              </div>
            </div>
            <h4 data-v-3ff3db88="" style="margin-top: 15px; margin-bottom: 15px;">客户信息</h4>
            <div data-v-3ff3db88="" class="certificate_type_spectial">
              <div data-v-3ff3db88="" class="el-row">
                <div data-v-3ff3db88="" class="el-col el-col-6">客户姓名</div>
                <div data-v-3ff3db88="" class="el-col el-col-17">
                  <div data-v-3ff3db88="" class="certificate_phone el-input">
                    <!----><input type="text" autocomplete="off" placeholder="请输入（必填）" class="el-input__inner">
                    <!---->
                    <!---->
                    <!---->
                    <!---->
                  </div>
                </div>
              </div>
            </div>
            <div data-v-3ff3db88="" class="certificate_type_spectial">
              <div data-v-3ff3db88="" class="el-row">
                <div data-v-3ff3db88="" class="el-col el-col-6">客户手机号</div>
                <div data-v-3ff3db88="" class="el-col el-col-17">
                  <div data-v-3ff3db88="" class="certificate_phone el-input">
                    <!----><input type="text" autocomplete="off" maxlength="11" placeholder="请输入（必填）" oninput="value=value.replace(/[^1\d]/g,'')" class="el-input__inner">
                    <!---->
                    <!---->
                    <!---->
                    <!---->
                  </div>
                </div>
              </div>
            </div>
            <div data-v-3ff3db88="" class="certificate_type_spectial">
              <div data-v-3ff3db88="" class="el-row">
                <div data-v-3ff3db88="" class="el-row">
                  <div data-v-3ff3db88="" class="el-col el-col-6">客户证件类型</div>
                  <div data-v-3ff3db88="" class="el-col el-col-17">
                    <div data-v-3ff3db88="" class="el-select el-select--medium">
                      <!---->
                      <div class="el-input el-input--medium el-input--suffix">
                        <!----><input type="text" readonly="readonly" autocomplete="off" placeholder="请选择" class="el-input__inner">
                        <!----><span class="el-input__suffix"><span class="el-input__suffix-inner"><i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </span>
                          <!---->
                        </span>
                        <!---->
                        <!---->
                      </div>
                      <div class="el-select-dropdown el-popper" style="display: none; min-width: 217px;">
                        <div class="el-scrollbar" style="">
                          <div class="el-select-dropdown__wrap el-scrollbar__wrap" style="margin-bottom: -5px; margin-right: -5px;">
                            <ul class="el-scrollbar__view el-select-dropdown__list">
                              <!---->
                              <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>身份证</span></li>
                              <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>其他</span></li>
                            </ul>
                          </div>
                          <div class="el-scrollbar__bar is-horizontal">
                            <div class="el-scrollbar__thumb" style="transform: translateX(0%);"></div>
                          </div>
                          <div class="el-scrollbar__bar is-vertical">
                            <div class="el-scrollbar__thumb" style="transform: translateY(0%);"></div>
                          </div>
                        </div>
                        <!---->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div data-v-3ff3db88="" class="certificate_type_spectial">
              <div data-v-3ff3db88="" class="el-row">
                <div data-v-3ff3db88="" class="el-col el-col-6">客户证件号</div>
                <div data-v-3ff3db88="" class="el-col el-col-17">
                  <div data-v-3ff3db88="" class="certificate_phone el-input">
                    <!----><input type="text" autocomplete="off" maxlength="18" placeholder="请输入（必填）" class="el-input__inner">
                    <!---->
                    <!---->
                    <!---->
                    <!---->
                  </div>
                </div>
              </div>
            </div>
            <!---->
            <div data-v-3ff3db88="" class="titWrap"><i data-v-3ff3db88="" class="titCircle"></i> <span data-v-3ff3db88="" class="tit">产权信息</span></div>
            <div data-v-3ff3db88="" class="el-form-item is-required">
              <!---->
              <div class="el-form-item__content">
                <div data-v-3ff3db88="" class="certificate_type_spectial">
                  <div data-v-3ff3db88="" class="el-row">
                    <div data-v-3ff3db88="" class="el-col el-col-6">用水地址所在区域</div>
                    <div data-v-3ff3db88="" class="el-col el-col-17">
                      <div data-v-3ff3db88="" class="el-select el-select--medium">
                        <!---->
                        <div class="el-input el-input--medium el-input--suffix">
                          <!----><input type="text" readonly="readonly" autocomplete="off" placeholder="请选择（必选）" class="el-input__inner">
                          <!----><span class="el-input__suffix"><span class="el-input__suffix-inner"><i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                            </span>
                            <!---->
                          </span>
                          <!---->
                          <!---->
                        </div>
                        <div class="el-select-dropdown el-popper" style="display: none; min-width: 217px;">
                          <div class="el-scrollbar" style="">
                            <div class="el-select-dropdown__wrap el-scrollbar__wrap" style="margin-bottom: -5px; margin-right: -5px;">
                              <ul class="el-scrollbar__view el-select-dropdown__list">
                                <!---->
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>福田区</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>罗湖区</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>罗湖区-莲塘</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>南山区</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>盐田区</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>宝安区</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>龙岗区</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>龙岗区-坪地</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>龙华区</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>坪山区</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>光明区</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>大鹏新区</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>大鹏新区-南澳</span></li>
                              </ul>
                            </div>
                            <div class="el-scrollbar__bar is-horizontal">
                              <div class="el-scrollbar__thumb" style="transform: translateX(0%);"></div>
                            </div>
                            <div class="el-scrollbar__bar is-vertical">
                              <div class="el-scrollbar__thumb" style="transform: translateY(0%);"></div>
                            </div>
                          </div>
                          <!---->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!---->
              </div>
            </div>
            <div data-v-3ff3db88="" class="el-form-item is-required">
              <!---->
              <div class="el-form-item__content">
                <div data-v-3ff3db88="" class="certificate_type_spectial">
                  <div data-v-3ff3db88="" class="el-row">
                    <div data-v-3ff3db88="" class="el-col el-col-6">房屋权属证明类型</div>
                    <div data-v-3ff3db88="" class="el-col el-col-17">
                      <div data-v-3ff3db88="" class="el-select el-select--medium">
                        <!---->
                        <div class="el-input el-input--medium el-input--suffix">
                          <!----><input type="text" readonly="readonly" autocomplete="off" placeholder="请选择（必选）" class="el-input__inner">
                          <!----><span class="el-input__suffix"><span class="el-input__suffix-inner"><i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                            </span>
                            <!---->
                          </span>
                          <!---->
                          <!---->
                        </div>
                        <div class="el-select-dropdown el-popper" style="display: none; min-width: 217px;">
                          <div class="el-scrollbar" style="">
                            <div class="el-select-dropdown__wrap el-scrollbar__wrap" style="margin-bottom: -5px; margin-right: -5px;">
                              <ul class="el-scrollbar__view el-select-dropdown__list">
                                <!---->
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>不动产权证</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>购房合同</span></li>
                                <li data-v-3ff3db88="" class="el-select-dropdown__item"><span>不动产权证号（免上传证件）</span></li>
                              </ul>
                            </div>
                            <div class="el-scrollbar__bar is-horizontal">
                              <div class="el-scrollbar__thumb" style="transform: translateX(0%);"></div>
                            </div>
                            <div class="el-scrollbar__bar is-vertical">
                              <div class="el-scrollbar__thumb" style="transform: translateY(0%);"></div>
                            </div>
                          </div>
                          <!---->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!---->
              </div>
            </div>
            <!---->
            <!---->
            <div data-v-3ff3db88="" class="el-form-item need_phone_special is-required">
              <!---->
              <div class="el-form-item__content">
                <div data-v-3ff3db88="" class="certificate_type_spectial">
                  <div data-v-3ff3db88="" class="el-row">
                    <div data-v-3ff3db88="" class="el-col el-col-6">用水详细地址</div>
                    <div data-v-3ff3db88="" class="el-col el-col-17">
                      <div data-v-3ff3db88="" class="certificate_phone el-input">
                        <!----><input type="text" autocomplete="off" placeholder="请输入（必填）" class="el-input__inner">
                        <!---->
                        <!---->
                        <!---->
                        <!---->
                      </div>
                    </div>
                  </div>
                </div>
                <!---->
              </div>
            </div>
            <!---->
            <div data-v-3ff3db88="" class="titWrap"><i data-v-3ff3db88="" class="titCircle"></i> <span data-v-3ff3db88="" class="tit">银行信息</span></div>
            <div data-v-3ff3db88="" class="certificate_type_spectial">
              <div data-v-3ff3db88="" class="el-row">
                <div data-v-3ff3db88="" class="el-col el-col-6">委托付款人信息</div>
                <div data-v-3ff3db88="" class="el-col el-col-17">与客户信息一致</div>
              </div>
            </div>
            <div data-v-3ff3db88="" class="el-form-item is-required">
              <!---->
              <div class="el-form-item__content">
                <div data-v-3ff3db88="" class="certificate_type_spectial">
                  <div data-v-3ff3db88="" class="el-row">
                    <div data-v-3ff3db88="" class="el-col el-col-6">托收银行</div>
                    <div data-v-3ff3db88="" class="el-col el-col-17">
                      <div data-v-3ff3db88="" class="el-select el-select--medium">
                        <!---->
                        <div class="el-input el-input--medium el-input--suffix">
                          <!----><input type="text" readonly="readonly" autocomplete="off" placeholder="请选择（必选）" class="el-input__inner">
                          <!----><span class="el-input__suffix"><span class="el-input__suffix-inner"><i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                            </span>
                            <!---->
                          </span>
                          <!---->
                          <!---->
                        </div>
                        <div class="el-select-dropdown el-popper" style="display: none; min-width: 217px;">
                          <div class="el-scrollbar" style="display: none;">
                            <div class="el-select-dropdown__wrap el-scrollbar__wrap" style="margin-bottom: -5px; margin-right: -5px;">
                              <ul class="el-scrollbar__view el-select-dropdown__list"></ul>
                            </div>
                            <div class="el-scrollbar__bar is-horizontal">
                              <div class="el-scrollbar__thumb" style="transform: translateX(0%);"></div>
                            </div>
                            <div class="el-scrollbar__bar is-vertical">
                              <div class="el-scrollbar__thumb" style="transform: translateY(0%);"></div>
                            </div>
                          </div>
                          <p class="el-select-dropdown__empty">
                            无数据
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!---->
              </div>
            </div>
            <div data-v-3ff3db88="" class="el-form-item ts_error_l is-required">
              <!---->
              <div class="el-form-item__content">
                <div data-v-3ff3db88="" class="certificate_type certificate_type_bank">
                  <div data-v-3ff3db88="" class="el-row">
                    <div data-v-3ff3db88="" class="el-col el-col-6">托收银行账号</div>
                    <div data-v-3ff3db88="" class="el-col el-col-17">
                      <div data-v-3ff3db88="" class="certificate_phone new_banknum">
                        <div data-v-3ff3db88="" class="bankcardInp el-input">
                          <!----><input type="text" autocomplete="off" maxlength="19" placeholder="请输入" class="el-input__inner">
                          <!---->
                          <!---->
                          <!---->
                          <!---->
                        </div> <input data-v-3ff3db88="" type="file" id="uploadBCard" class="upload_icon"> <label data-v-3ff3db88="" for="uploadBCard"><i data-v-3ff3db88=""
                             class="upload_bankcard"></i></label>
                      </div>
                    </div>
                  </div>
                  <div data-v-3ff3db88="" class="scanFace-tip"><i data-v-3ff3db88="" class="el-icon-info tipIcon"></i> <span data-v-3ff3db88="" class="tipText">仅限桐庐本地开户的借记卡</span></div>
                </div>
                <!---->
              </div>
            </div>
            <div data-v-3ff3db88="" class="el-form-item is-required">
              <!---->
              <div class="el-form-item__content">
                <div data-v-3ff3db88="" class="certificate_type_spectial">
                  <div data-v-3ff3db88="" class="el-row">
                    <div data-v-3ff3db88="" class="el-col el-col-6">上传银行卡照片</div>
                    <div data-v-3ff3db88="" class="el-col el-col-18">
                      <div data-v-3ff3db88="" class="take_photo_ls">
                        <div data-v-3ff3db88="" class="prove_photo"><input data-v-3ff3db88="" type="file" id="bank1" accept="image/*" class="idcard_side"> <label data-v-3ff3db88="" for="bank1"
                                 class="photo_box">
                            <div data-v-3ff3db88="" class="img_box"><img data-v-3ff3db88=""
                                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAcCAYAAAB/E6/TAAAAAXNSR0IArs4c6QAAAJJJREFUSA1jZCABzJgxoxxZeUZGRicyHx+bBZ8kuhwjI2MHmhjRFjGhaaQZd9QisoN2NOhGgw4eAnRLDIwzZ87cDbeWMMMFTckeND5OLqisQ9eMUzEWCaL10i3o6GYRI5bgwCkEjM//yJLp6elE66ebj0YtQo4iktijQUdScCErHg065NAgiQ0qvUkBRFcL6IYCAFVDDhqwvshjAAAAAElFTkSuQmCC"
                                   class="prove_img"></div>
                          </label>
                          <p data-v-3ff3db88="" class="take_photo_tip">银行卡正面</p>
                        </div>
                        <div data-v-3ff3db88="" class="prove_photo"><input data-v-3ff3db88="" type="file" id="bank2" accept="image/*" class="idcard_side"> <label data-v-3ff3db88="" for="bank2"
                                 class="photo_box">
                            <div data-v-3ff3db88="" class="img_box"><img data-v-3ff3db88=""
                                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAcCAYAAAB/E6/TAAAAAXNSR0IArs4c6QAAAJJJREFUSA1jZCABzJgxoxxZeUZGRicyHx+bBZ8kuhwjI2MHmhjRFjGhaaQZd9QisoN2NOhGgw4eAnRLDIwzZ87cDbeWMMMFTckeND5OLqisQ9eMUzEWCaL10i3o6GYRI5bgwCkEjM//yJLp6elE66ebj0YtQo4iktijQUdScCErHg065NAgiQ0qvUkBRFcL6IYCAFVDDhqwvshjAAAAAElFTkSuQmCC"
                                   class="prove_img"></div>
                          </label>
                          <p data-v-3ff3db88="" class="take_photo_tip">银行卡背面</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!---->
              </div>
            </div>
            <div data-v-3ff3db88="" class="el-form-item need_phone_special">
              <!---->
              <div class="el-form-item__content">
                <div data-v-3ff3db88="" class="certificate_type_spectial">
                  <div data-v-3ff3db88="" class="el-row">
                    <div data-v-3ff3db88="" class="el-col el-col-6">联系邮箱</div>
                    <div data-v-3ff3db88="" class="el-col el-col-17">
                      <div data-v-3ff3db88="" class="certificate_phone el-input">
                        <!----><input type="text" autocomplete="off" placeholder="请输入（选填）" class="el-input__inner">
                        <!---->
                        <!---->
                        <!---->
                        <!---->
                      </div>
                    </div>
                  </div>
                  <div data-v-3ff3db88="" class="scanFace-tip"><i data-v-3ff3db88="" class="el-icon-info tipIcon"></i> <span data-v-3ff3db88="" class="tipText">用于接收电子发票和电子收据</span></div>
                </div>
                <!---->
              </div>
            </div>
          </form>
          <div data-v-3ff3db88="" class="greyBtnWrap">
            <p data-v-3ff3db88="" style="padding: 20px 0px;">提交前，请仔细阅读以下合同、协议并勾选确认:</p>
            <p data-v-3ff3db88="" class="round-li">《桐庐县城市供（排）水合同》</p>
            <p data-v-3ff3db88="" class="round-li">《委托银行代收款协议书》</p>
            <div data-v-3ff3db88="" class="understand"><span data-v-3ff3db88="" class="check_icon"><i data-v-3ff3db88="" class="el-icon-check"></i></span> <span data-v-3ff3db88=""
                    class="isAgree">本人已阅读并同意以上合同、协议。如因办理此业务产生争议，供水企业有权单方撤销本次办理业务。</span></div> <button data-v-3ff3db88="" disabled="disabled" type="button"
                    class="el-button mt10 el-button--primary is-disabled">
              <!---->
              <!----><span>确认提交</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
</style>